module.exports = __webpack_public_path__ + "img/bay-hotel.916fac2e.jpg";